import React, {useEffect, useState} from "react";
import libToast from "../../lib/LibToast";
import Api from "../../servicios/api/Api";
import CLoading from "../CLoading";
import CError from "../../pageComponents/CError";
import CLinkDescargaPlantillaCrearEse from "./CLinkDescargaPlantillaCrearEse";


const apiCliente = Api.getApiCliente();

const SolicitarConExcel = () => {
  
  const [att, setAtt] = useState({isLoading: true})
  const [eseTipoList, setEseTipoList] = useState([])
  
  
  useEffect(() => {
    //cargar datos del api
    (async () => {
      const response = await apiCliente.solicitarConExcel();
      if (!response.success) {
        libToast.alert("Error " + response.message);
        setAtt({isError: true, mesage: response.message});
      }
      setEseTipoList(response.data["ese-tipo"]);
      setAtt({success: true});
    })()
    
  }, []);
  
  
  if (att.isLoading) {
    return <CLoading/>
  }
  
  if (att.isError) {
    return <CError message={att.message}/>
  }
  
  
  const onChange = () => {
  
  }
  
  const submit = async () => {
  
  }
  
  return (<div>
    <CLinkDescargaPlantillaCrearEse/>

  </div>)
  
}


export default SolicitarConExcel;

